import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { ServicesService } from '../services/services.service';
import { MonitorDetailsState } from './monitor-details.state';
import { MonitorService } from './monitors.service';
import { MonitorState } from './monitors.state';

@NgModule({
  declarations: [],
  imports: [NgxsModule.forFeature([MonitorState, MonitorDetailsState])],
  providers: [MonitorService, ServicesService],
  exports: [],
})
export class MonitorsStateModule {}
